import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { GoogleAnalyticsService } from '@dx/common';
import { PlatformService, PlatformFeature } from '@dx/platform-components';

import { environment } from '../../../environments/environment';
import { Config } from './config.model';

export { Config };

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private activationStatusSubject = new BehaviorSubject<boolean | null>(null);
  private http: HttpClient;
  private _config: Config;

  constructor(
    private httpBackend: HttpBackend,
    private googleAnalyticsService: GoogleAnalyticsService,
    private platformService: PlatformService,
    private client: HttpClient
  ) {
    this.http = new HttpClient(httpBackend);
  }

  get config(): Config {
    return this._config;
  }

  get hasLossRun(): boolean {
    return this.platformService.hasFeature(PlatformFeature.LossRun);
  }

  get activationStatus$(): Observable<boolean | null> {
  return this.activationStatusSubject.asObservable();
  }

  loadConfig(): Promise<Config> {
    return this.http.get<Config>(environment.configSource).pipe(
      tap(resp => {
        this._config = resp;
        this.platformService.config = this._config.platformConfig;
        this.googleAnalyticsService.loadScript(this._config.analyticsId);
      })
    ).toPromise();
  }

  getUserStatus(): Observable<boolean> {
    return this.client.get<boolean>(`${this.platformService.apiUrl}/api/user/activestatus`);
  }


  // /** Call this once during app initialization */
  // loadUserStatus(): void {
  //   this.getUserStatus().subscribe({
  //     next: (status) => this.activationStatusSubject.next(status),
  //     error: () => this.activationStatusSubject.next(false), // fallback
  //   });
  // }

  // /** Optional: get current value synchronously */
  // getCurrentUserStatus(): boolean | null {
  //   return this.activationStatusSubject.value;
  // }

  setUserStatus(status: boolean): void {
  this.activationStatusSubject.next(status);
}

}